module.exports = __webpack_public_path__ + "img/sin_imagen.be5f8b19.png";